import React from 'react';
import { getVersion } from '../utils/version';

const SplashScreen = ({ companyName = 'Modulpanel' }) => {
  const version = getVersion();
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'radial-gradient(circle at 30% 20%, rgba(56, 189, 248, 0.10), transparent 55%), radial-gradient(circle at 80% 80%, rgba(59, 130, 246, 0.10), transparent 60%), #0b1220',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeOut 0.5s ease-out 1.5s forwards'
    }}>
      <style>
        {`
          @keyframes fadeOut {
            from { opacity: 1; }
            to { opacity: 0; }
          }

          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.05); opacity: 0.8; }
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* Logo/Icon */}
      <div style={{
        fontSize: '5rem',
        marginBottom: '1.5rem',
        animation: 'pulse 2s ease-in-out infinite',
        filter: 'drop-shadow(0 0 24px rgba(56, 189, 248, 0.35))'
      }}>
        🏭
      </div>

      {/* Program Name */}
      <h1 style={{
        color: '#e5e9f0',
        fontSize: '3rem',
        fontWeight: 700,
        marginBottom: '0.5rem',
        animation: 'slideUp 0.6s ease-out',
        textAlign: 'center',
        letterSpacing: '-0.5px'
      }}>
        Produksjonsstyring
      </h1>

      {/* 'for' label */}
      <p style={{
        color: 'rgba(148, 163, 184, 0.6)',
        fontSize: '0.9rem',
        marginBottom: '0.3rem',
        animation: 'slideUp 0.6s ease-out 0.15s backwards',
        textAlign: 'center',
        fontStyle: 'italic'
      }}>
        for
      </p>

      {/* Company Name */}
      <p style={{
        color: '#7dd3fc',
        fontSize: '1.5rem',
        marginBottom: '0.5rem',
        animation: 'slideUp 0.6s ease-out 0.2s backwards',
        textAlign: 'center',
        fontWeight: 500
      }}>
        {companyName}
      </p>

      {/* Version Number */}
      <p style={{
        color: '#94a3b8',
        fontSize: '0.9rem',
        marginBottom: '0.5rem',
        animation: 'slideUp 0.6s ease-out 0.3s backwards',
        textAlign: 'center',
        opacity: 0.8
      }}>
        v{version}
      </p>

      {/* Author */}
      <p style={{
        color: '#64748b',
        fontSize: '0.8rem',
        marginBottom: '2rem',
        animation: 'slideUp 0.6s ease-out 0.4s backwards',
        textAlign: 'center',
        opacity: 0.7
      }}>
        © Copyright Emir Muric
      </p>

      {/* CAD Reader stamp */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.4rem',
        background: 'rgba(56, 189, 248, 0.08)',
        border: '1px solid rgba(56, 189, 248, 0.25)',
        borderRadius: '10px',
        padding: '0.3rem 0.8rem',
        marginBottom: '1.5rem',
        animation: 'slideUp 0.6s ease-out 0.5s backwards'
      }}>
        <span style={{ fontSize: '1.1rem' }}>📐</span>
        <span style={{
          color: '#7dd3fc',
          fontSize: '0.75rem',
          fontWeight: 600,
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }}>with CAD Reader</span>
      </div>

      {/* Loading Spinner */}
      <div style={{
        width: '50px',
        height: '50px',
        border: '4px solid rgba(56, 189, 248, 0.18)',
        borderTop: '4px solid #38bdf8',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
    </div>
  );
};

export default SplashScreen;
